import { ICreateLeadResult } from 'marketing-site/lib/marketo/@types/submitForm'
import { captureException } from 'marketing-site/lib/sentry'

export const handleSkippedSubmissionErrors = (result: ICreateLeadResult | undefined) => {
  if (result?.status === 'skipped') {
    const reasons = result.reasons?.map((reason) => reason.message).join(', ')
    captureException(new Error(`Form submission was skipped: ${reasons}`))
  }
}
